/** Custom roleEntityId identifies a custom user, never a company or group. */
export function resolveCrewingActorCompanyScope(user: any, isCustomRole: boolean) {
  const positiveId = (value: unknown): number | undefined => {
    const id = Number(value)
    return Number.isFinite(id) && id > 0 ? id : undefined
  }
  return {
    companyGroupId: positiveId(user?.companyGroupAdminId ?? user?.companyGroupAdmin?.id),
    companyAdminId: positiveId(user?.companyAdminId ?? user?.companyAdmin?.id),
    legacyEntityId: isCustomRole ? undefined : positiveId(user?.roleEntityId),
  }
}
